import { FilterInputProps, SelectFilter } from '@/core/components';

type SourceTypeFilterProps = FilterInputProps;

export function SourceTypeFilter(props: SourceTypeFilterProps) {
  const options = ['WOS', 'SCOPUS', 'MANUAL'].map(value => ({ label: value, value }));
  return (
    <SelectFilter
      isError={false}
      isLoading={false}
      options={options}
      {...props}
    />
  );
}
